<template>
	<div class="pnf">
		<div class="pnf__elm">
			<!-- //////////////// -->
			<!-- PAGE NOT FOUND -->
			<Error404 />
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Error404 from "@/components/errors/Error404.vue";

@Options({
	components: { Error404 },
})
export default class PageNotFoundView extends Vue {}
</script>

<style scoped lang="scss">
.pnf {
	display: flex;
	justify-content: center;

	&__elm {
		padding-top: 24px;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		max-width: 649px;
	}

	@media screen and (max-width: 768px) {
		&__elm {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			padding: 12px;
			min-width: 100px;
		}
	}
}
</style>
